import { render } from "./ReqAgentBusinessCardView.vue?vue&type=template&id=26223800"
import script from "./ReqAgentBusinessCardView.vue?vue&type=script&lang=js"
export * from "./ReqAgentBusinessCardView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__